import packageConfig from "./../../package.json";

// 公共的路径前缀，包括构建引入文件路径和访问数据都会带上些前缀
const publicPath = packageConfig.homepage ? packageConfig.homepage : "/";
// 登录页面地址
const loginUrl = `${publicPath}login`;
// 独立页面，不需要头尾
const alonePath = ["/login", "/verify"];
// 展示未登录Header的页面
const unLoginHeader = ["/403", "/forgot_password", "/register_account"];
// 需要footer背景图的页面
const footerBgPath = ["/", "/home"];
// 不需要footer的页面
const unFooterPath = [
  "/staging",
  "/app_detail",
  "/user/info",
  "/videoCollection",
  "/message",
  '/expense',
  '/orderPay',
  '/onlineRecharge',
  '/video/pc',
  '/video/fly',
  '/document/kaihong-developer-documents/kaihongos-guides'
];
export const FREE_DOWNLOAD_PATH = "/freedownload";
/** 资源下载页 x86 桌面版板块锚点（登录回流、x86 详情页跳转） */
export const DESKTOP_X86_DOWNLOAD_SECTION_ID = "desktop_x86_version_download";
/** KaihongOS 桌面版（x86）详情页路由 */
export const X86_PAGE_PATH = "/x86";
/** KaihongOS 桌面版（x86）镜像获取 / U盘购买页路由 */
export const X86_OBTAIN_PAGE_PATH = "/x86/obtain";
/** 试用版安装镜像包 download key（详情页 / 资源下载 / obtain 共用） */
export const DESKTOP_X86_TRIAL_V500_KEY = "image_kaihong_desktop_x86_v500";
/** 入口按钮文案：跳转 obtain，真正下载在 obtain 页完成 */
export const BTN_X86_OBTAIN_TEXT = "立即获取";
// 不需要登录的页面，取name
const unAuthPath = [
  "/403",
  "/login",
  "/forgot_password",
  "/register_account",
  "/home",
  "/applicationDevelopment",
  "/equipmentDevelopment",
  "/wikiKaihongosGuides",
  "/videoPlayer",
  "/videoCollection",
  "/video/pc",
  "/video/fly",
  "/questions",
  FREE_DOWNLOAD_PATH,
  "/kaihong-developer-documents/application-develop-guides",
  "/kaihong-developer-documents/device-develop-guides",

  "/ecological",
  "/document_resources",
  "/service_support",
  "/document",
  "/document/kaihong-developer-document",
  "/resource",
  "/design",
  "/design_story",
  "/technicalSupport/notice",
  "/technicalSupport/feedback",
  "/technicalSupport/faq",
  "/technicalSupport/noticeDetail",
  "/technicalSupport/feedbackDetail",
  "/technicalSupport/faqDetail",
  "/activity/x86-beta",
  "/activity/x86-beta/signup",
  "/x86",
  "/X86", // 旧路径兼容（会重定向到 /x86）
  "/x86/obtain",
  "/X86/obtain", // 旧路径兼容（会重定向到 /x86/obtain）
];
// 不需要登录的api
const unAuthApi = [
  "/message/code/common/sms/login",
  "/login",
  "/sms/login",
  "/message/code/common/sms/register",
  "/message/code/common/sms/reset/password",
  "/user/register",
  "/user/reset/password",
  "/user/check/phone",
  "/community/downloadIntent/create",
];

// 点击头部logo跳转到工作台而非首页的页面
const toStagingPath = ["/app_detail", "/staging"];

// 需要整屏滚动的页面
const fullScreenScrolling = ["/", "/home"];

const PROCESS_ENV_NODE: any = process.env.NODE_ENV;

const authCookieConfig = {
  expires: 7, // 有效期
  path: "/", // path
  domain: PROCESS_ENV_NODE !== "development" ? ".kaihong.com" : "", // domain
};

const KaihongMallDomain =
  PROCESS_ENV_NODE === "production"
    ? "https://mall.kaihong.com"
    : PROCESS_ENV_NODE === "preRelease"
    ? "https://dev-developer.kaihong.com"
    : "https://dev-developer.kaihong.com";

export {
  publicPath,
  alonePath,
  loginUrl,
  unLoginHeader,
  footerBgPath,
  unFooterPath,
  unAuthPath,
  unAuthApi,
  toStagingPath,
  fullScreenScrolling,
  authCookieConfig,
  PROCESS_ENV_NODE,
  KaihongMallDomain,
};
